import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface PlatformBatchMenuProps {
  visibility?: {
    batch: boolean;
    job: boolean;
    batchUploadFile: boolean;
    batchDownloadFile: boolean;
  };
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const PlatformBatchMenu = ({
  visibility = {
    batch: false,
    job: false,
    batchUploadFile: true,
    batchDownloadFile: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: PlatformBatchMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Piattaforma Batch" />
      </ListItem>
      <Menu
        id="batchplatform-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        {visibility.batch
          ? [
              <MenuItem
                key="platform-batch-management-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/gestione-batch');
                }}
              >
                <Typography variant="inherit">Gestione Batch</Typography>
              </MenuItem>,
              <Divider key="platform-batch-management-divider" hidden={!visibility.job} />,
            ]
          : undefined}
        {visibility.job
          ? [
              <MenuItem
                key="platform-batch-job-processing-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/elaborazione-job');
                }}
              >
                <Typography variant="inherit">Elaborazione Job</Typography>
              </MenuItem>,
              <Divider
                key="platform-batch-job-processing-divider"
                hidden={!visibility.batchUploadFile}
              />,
            ]
          : undefined}
        {visibility.batchUploadFile
          ? [
              <MenuItem
                key="platform-batch-upload-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/gestione-batch/gestione-file/upload');
                }}
              >
                <Typography variant="inherit">Gestione File - Upload</Typography>
              </MenuItem>,
              <Divider
                key="platform-batch-upload-divider"
                hidden={!visibility.batchDownloadFile}
              />,
            ]
          : undefined}

        {visibility.batchDownloadFile
          ? [
              <MenuItem
                key="platform-batch-download-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/gestione-batch/gestione-file/download');
                }}
              >
                <Typography variant="inherit">Gestione File - Download</Typography>
              </MenuItem>,
              <Divider
                key="platform-batch-download-divider"
                hidden={!visibility.batchDownloadFile}
              />,
            ]
          : undefined}

        {visibility.batchDownloadFile ? (
          <MenuItem
            key="platform-batch-download-anpr-item"
            onClick={(event) => {
              onClose(event);
              navigate('/sistema/gestione-batch/gestione-file/download-anpr');
            }}
          >
            <Typography variant="inherit">Gestione File - Download ANPR</Typography>
          </MenuItem>
        ) : undefined}
      </Menu>
    </Fragment>
  );
};

PlatformBatchMenu.displayName = 'Platform Batch Menu';

export default PlatformBatchMenu;
